<template>
    <div v-if="loaded" class="vacantion">
        <div v-if="options.length">
            <h3>Стань частью нашей команды!</h3>
            <p>Мы - одни из крупнейших обувных компаний России специализирующаяся на продаже качественной и комфортной обуви мировых европейских производителей.</p>
            <q-list>
                <q-expansion-item
                    v-for="(item, key) in options"
                    :key="key"
                    expand-separator
                    header-class="vacantion-item"
                    :label="item.name"
                >
                    <q-card>
                        <q-card-section>
                            <div class="vacantion-item-body">
                                <div class="vacantion-item-option"><span>заработная плата:</span>
                                    <ul>
                                        <li>{{ item.salary }}</li>
                                    </ul>
                                </div>
                                <div class="vacantion-item-option" v-if="item.responsibilities"><span>обязанности:</span>
                                    <ul>
                                        <li v-for="responsibility in item.responsibilities.split('\n')">{{ responsibility }}</li>
                                    </ul>
                                </div>
                                <div class="vacantion-item-option" v-if="item.requirements"><span>требования:</span>
                                    <ul>
                                        <li v-for="requirement in item.requirements.split('\n')">{{ requirement }}</li>
                                    </ul>
                                </div>
                                <div class="vacantion-item-option" v-if="item.conditions"><span>условия:</span>
                                    <ul>
                                        <li v-for="condition in item.conditions.split('\n')">{{ condition }}</li>
                                    </ul>
                                </div>
                                <div class="vacantion-item-option" v-if="item.benefits">
                                    <span>дополнительно для наших сотрудников:</span>
                                    <ul>
                                        <li v-for="benefit in item.benefits.split('\n')">{{ benefit }}</li>
                                    </ul>
                                </div>
                            </div>

                            <div v-show="!forms[key].sent">
    <!--                            <q-select
                                    square
                                    outlined
                                    dense
                                    emit-value
                                    map-options
                                    v-model="form.vacancy_id"
                                    :options="options"
                                    :option-value="(item) => item.id"
                                    :option-label="(item) => item.name"
                                    :error-message="getError('vacancy_id')"
                                    :error="hasError('vacancy_id')"
                                />-->

                                <div class="row q-col-gutter-md">
                                    <div class="col-12 col-md-6">
                                        <q-file borderless
                                                @input="fileChange($event, key, 'doc')"
                                                :value="forms[key].doc"
                                                ref="doc"
                                                :error-message="getError(key, 'doc')"
                                                :error="hasError(key, 'doc')">
                                            <template v-slot:append>
                                                <div class="custom-file-label cursor-pointer" @click="pick(key, 'doc')">{{ forms[key].docLabel }}</div>
                                            </template>
                                        </q-file>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <q-file borderless
                                                @input="fileChange($event, key, 'image')"
                                                :value="forms[key].image"
                                                ref="image"
                                                :error-message="getError(key, 'image')"
                                                :error="hasError(key, 'image')"
                                        >
                                            <template v-slot:append>
                                                <div class="custom-file-label cursor-pointer" @click="pick(key, 'image')">{{ forms[key].imageLabel }}</div>
                                            </template>
                                        </q-file>
                                    </div>
                                </div>

                                <q-btn @click.prevent="submitResume(key)" label="Откликнуться на вакансию" outline color="black" class="mb-2" />

                                <q-item tag="label" v-ripple>
                                    <q-item-section avatar>
                                        <q-checkbox :value="forms[key].accept" @input="setValue(key, 'accept', !forms[key].accept)" label="" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label>нажимая «Откликнуться на вакансию», вы соглашаетесь с правилами обработки персональных данных</q-item-label>
                                    </q-item-section>
                                </q-item>

                                <div class="q-field--error" v-if="hasError(key, 'accept')">
                                    <div class="q-field__bottom">{{ getError(key, 'accept') }}</div>
                                </div>
                            </div>

                            <div v-show="forms[key].sent">{{ forms[key].responseMessage }}</div>

                        </q-card-section>
                    </q-card>
                </q-expansion-item>
            </q-list>
        </div>
        <p v-else>На данный момент в вашем городе нет открытых вакансий.</p>
    </div>
</template>

<script>
    import { FileForm } from '../../classes/FileForm';
    import {mapState} from "vuex";

    export default {
        name: "Vacancies",
        data () {
            return {
                loaded: false,
                response: '',
                options: [],
                selected: {},
                forms: [],
                docLabel: 'Резюме',
                imageLabel: 'Фото',
                accept: true,
            }
        },
        watch: {
            location(newValue, oldValue) {
                this.loadData();
            }
        },
        mounted () {
            this.loadData();
        },
        methods: {
            loadData () {
                let _this = this;

                axios.get('/vacancy-list')
                    .then(response => {
                        if (response.data.status === 'success') {

                            if (response.data.data) {
                                for (let i in response.data.data) {
                                    this.forms[i] = new FileForm({
                                        vacancy_id: response.data.data[i].id,
                                        doc: new File([""], ''),
                                        image: new File([""], ''),
                                        accept: false,
                                        docLabel: 'Резюме',
                                        imageLabel: 'Фото',
                                        sent: false,
                                        responseMessage: null,
                                    })
                                }

                                _this.options = response.data.data;
                            }

                            _this.loaded = true;
                        }
                    });
            },
            reloadForms () {
                let forms = _.cloneDeep(this.forms);

                this.forms = null;

                this.forms = _.cloneDeep(forms);
            },
            pick (key, name) {
                // console.log(this.$refs[name]);
                this.$refs[name][key].pickFiles();
            },
            fileChange (file, key, field) {
                if (file) {
                    this.forms[key][field] = file;
                    this.$set(this.forms[key], field + 'Label', file.name);
                    // this.forms[key][field + 'Label'] = file.name;
                    // this[`${field}Label`] = file.name;
                }
            },
            submit (key) {
                let _this = this;

                this.forms[key].post('/resumes')
                    .then(response => {
                        if (response.message) {
                            this.$set(this.forms[key], 'sent', true);
                            this.$set(this.forms[key], 'responseMessage', response.message);

                            this.reloadForms();
                        }
                    })
                    .catch(error => {
                        this.reloadForms();
                    });
            },
            submitResume (key) {
                let _this = this;
                _this.submit(key);
            },
            hasError (key, field) {
                return this.forms[key].errors.has(field);
            },
            getError (key, field) {
                return this.forms[key].errors.get(field);
            },
            setValue (key, field, value) {
                this.forms[key][field] = value;

                this.reloadForms();
            }
        },
        computed: {
            ...mapState('geo', [
                'location',
            ])
        },
    }
</script>
